import { all, takeLeading } from "redux-saga/effects";
import { shopActionConstants } from "@/store/actions/shop.actions";
import { _sharedWorkerFetchShopBooks } from "@/shared/store/shop/saga";

export default function* shopSaga() {
  yield all([
    takeLeading(shopActionConstants.FETCH_SHOP_BOOKS, _sharedWorkerFetchShopBooks),
  ]);
};
